export class Action {
  icon: string;
  name?: string;
  fn: (id?: unknown) => void;

  constructor(icon: string, name?: string, fn?: (id: unknown) => void) {
    this.icon = icon;
    this.name = name;
    this.fn = fn;
  }

  setFunction(fn: (id: unknown) => void): Action {
    return {
      ...this,
      fn
    };
  }
}
